import type { Plan, PricingResponse } from '../types';

function savingsBadge(pricing: PricingResponse): string | null {
  const annual = pricing.plans.annual.amount;
  const monthly = pricing.plans.monthly.amount;
  if (annual == null || monthly == null) return null;
  const monthlyYearly = monthly * 12;
  if (monthlyYearly <= annual) return null;
  const saved = Math.round((monthlyYearly - annual) / 100);
  return `SAVE $${saved}/YR`;
}

export function PlanToggle({
  pricing,
  selected,
  onSelect,
  disabled,
}: {
  pricing: PricingResponse;
  selected: Plan;
  onSelect: (p: Plan) => void;
  disabled?: boolean;
}) {
  const badge = savingsBadge(pricing);
  const order: Plan[] = ['annual', 'monthly'];

  return (
    <div className="plan-toggle" role="radiogroup" aria-label="Billing plan">
      {order.map((plan) => {
        const p = pricing.plans[plan];
        const isSelected = selected === plan;
        return (
          <button
            key={plan}
            type="button"
            role="radio"
            aria-checked={isSelected}
            className={`plan-option ${isSelected ? 'selected' : ''}`}
            onClick={() => !disabled && onSelect(plan)}
            disabled={disabled}
          >
            {plan === 'annual' && badge ? <span className="plan-badge">{badge}</span> : null}
            <div className="plan-label">{plan === 'annual' ? 'Annual' : 'Monthly'}</div>
            <div className="plan-price">{p.displayAmount}</div>
            <div className="plan-interval">{p.displayInterval}</div>
          </button>
        );
      })}
    </div>
  );
}
